import CookieNotice from '@/components/cookie-notice';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

export default function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif text-ink tracking-tight">CANETA</h1>
          <p className="text-sepia mt-2">{t('auth.tagline')}</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-lg p-8" style={{ boxShadow: 'var(--shadow-md)' }}>
          <Outlet />
        </div>
      </div>
      <CookieNotice />
    </div>
  );
}
